export const FeeProviderLocationType = {
  PRIMARY: 'Primary',
  SECONDARY: 'Secondary',
};

export const FeeProviderPaidToType = {
  BROKER: 'Broker',
  BROKER_AFFILIATE: 'BrokerAffiliate',
  INVESTOR: 'Investor',
  LENDER: 'Lender',
  LENDER_AFFILIATE: 'LenderAffiliate',
  OTHER: 'Other',
  HUD: 'HUD',
  SERVICE_PROVIDER: 'ServiceProvider',
  USDA: 'USDA',
  VA: 'VA',
  SELLER: 'Seller',
};
